<template>
  <div class="input-form">
    <label :for="name">
      {{ label }}
      <span v-if="required && label" class="text-red font-bold"> * </span>
    </label>
    <Field
      :id="name"
      v-model="value"
      :as="as"
      :name="name"
      :type="type"
      :rules="rules"
      :maxlength="max ? max : false"
      :max="name == 'birth_at' ? minimumDate : false"
      :placeholder="placeholder ?? label"
      :disabled="disabled"
      class="inputForm"
    />
    <div v-if="name == 'address1' && value.length >=32" class="font-bold text-[#F6983F] mt-1">
      <p>Attention, vous avez atteint le nombre maximum de caractères (32).</p>
      <p>Merci de remplir le complément d'adresse au besoin.</p>
    </div>
    <div>
      <ErrorMessage class="errorForm" :name="name" />
    </div>
    <div>
      <span
        v-if="errors && errors[name] && errors[name][0]"
        class="errorForm"
        >{{ errors[name][0] }}</span
      >
    </div>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
export default {
  components: {
    Field,
    ErrorMessage
  },
  props: {
    as: {
      type: String,
      default: 'input'
    },
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    rules: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => {}
    },
    max : {
      type: Number
    },
    min : {
      type: Number
    },
  },
  emits: ['update:modelValue'],
  computed: {
    minimumDate() {
      var eighteenYearsAgo = new Date();
      eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear()-18);
      return eighteenYearsAgo.toISOString().split('T')[0];
    },
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>
